module.exports = __webpack_public_path__ + "img/0Q3A5767_L_Foamcore_MockedUp.746dc4d8.jpg";